import { autoMount } from '../../../utils/autoMount';
import { PrivacyPolicy } from '../../../components/pages/privacyPolicy';

autoMount({ PrivacyPolicy });
